import { Theme } from '@mui/material/styles';
import { SxProps } from '@mui/system';
import { YodaColors, YodaFontSize } from '../../yoda-ui/yodaTheme';

export const adminDashboardFiltersTitle: SxProps<Theme> = {
  fontWeight: 700,
  marginBottom: '24px',
  fontSize: YodaFontSize.xLarge,
};

export const adminDashboardFiltersForm: SxProps<Theme> = (theme) => ({
  display: 'grid',
  width: '100%',
  gap: '16px',

  gridTemplateColumns: '1fr',

  [theme.breakpoints.up('md')]: {
    gridTemplateColumns: 'repeat(12, 1fr)',
  },

  '& > div': {
    width: '100% !important',
    marginBottom: '0 !important',

    [theme.breakpoints.up('md')]: {
      '&:nth-of-type(-n+3)': {
        gridColumn: 'span 4',
      },

      '&:nth-of-type(4)': {
        gridColumn: 'span 3',
      },

      '&:nth-of-type(5)': {
        gridColumn: 'span 3',
      },

      '&:nth-of-type(6)': {
        gridColumn: 'span 6',
      },
    },
  },
});

export const adminDashboardSelectedTags: SxProps<Theme> = {
  marginTop: '16px',
  display: 'flex',
  rowGap: '16px',
  columnGap: '8px',
  flexWrap: 'wrap',
};

export const resetButtonStyle: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  gap: '6px',
  cursor: 'pointer',
  color: YodaColors.blue7,
  fontWeight: 500,
  fontSize: '14px',
  userSelect: 'none',
  transition: 'opacity 0.2s',
  '&:hover': { opacity: 0.8 },
};
